import React from 'react';
import styled from 'styled-components';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ArrowUpDown } from 'lucide-react';

const SortContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.5rem 0;
`;

const SortLabel = styled.span`
  font-size: 0.85rem;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 0.35rem;
`;

interface SelectMatchesSortProps {
  value: string;
  onChange: (value: string) => void;
  matchType: 'role' | 'candidate';
}

const roleSortOptions = [
  { value: 'updatedAt', label: 'Recently Updated' },
  { value: 'clientName', label: 'Client Name' },
  { value: 'jobTitle', label: 'Role Title' },
  { value: 'currentStatus', label: 'Status' },
];

const candidateSortOptions = [
  { value: 'updatedAt', label: 'Recently Updated' },
  { value: 'candidateName', label: 'Candidate Name' },
  { value: 'jobTitle', label: 'Role Title' },
  { value: 'currentStatus', label: 'Status' },
];

/**
 * Dropdown for sorting matches on mobile
 */
const SelectMatchesSort: React.FC<SelectMatchesSortProps> = ({
  value,
  onChange,
  matchType,
}) => {
  const options = matchType === 'role' ? roleSortOptions : candidateSortOptions;

  return (
    <SortContainer>
      <SortLabel>
        <ArrowUpDown size={14} />
        Sort by:
      </SortLabel>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Sort by..." />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </SortContainer>
  );
};

export default SelectMatchesSort;
